export default function getBedbankPromoExtraValue(data: {
  value: number,
  price: number,
  minLos: number,
  duration: number,
}): number {
  return ((data.value - data.price) / data.minLos) * data.duration
}
